export default __webpack_public_path__ + "assets/images/03656f9709826d21470686e187a05adc.png";